import axiosPrivate from "@services/axiosPrivate"
import { ADD_COMMENT } from "src/constants"

export const addComment = (data) => {
  return axiosPrivate.post(ADD_COMMENT, data, {
    withCredentials: true,
  })
}
